import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { Text } from "@components/Text";
import { convertFormatDate } from "@utils/convertFormatDate";
import { formatBytes } from "@utils/formatBytes";

const Container = styled.div`
  width: 300px;
`;

export const ContentInfo = ({ mediaInfo }) => {
  const size = _.get(mediaInfo, ["size"]);
  const duration = _.get(mediaInfo, ["duration"]);
  const name = _.get(mediaInfo, ["display_name"]);
  const extension = _.get(mediaInfo, ["extension"]);
  const uploadAt = _.get(mediaInfo, ["created_at"]);
  const convertSize = formatBytes({ bytes: size });

  return (
    <Container>
      <Text>Name : {name}</Text>
      <Text>Size : {convertSize}</Text>
      <Text>Duration : {duration} seconds</Text>
      <Text>Extension : {extension}</Text>
      <Text>Upload At : {convertFormatDate({ date: uploadAt })}</Text>
    </Container>
  );
};
